module.exports = __webpack_public_path__ + "static/img-subheader-22c072f7e0dbfba7f18a6a8d0b7d83f1.png";